import StyledBootStrapInput from '@components/UI-Components/StyledBootStrapInput'
import { Grid, MenuItem, Select, makeStyles } from '@material-ui/core'
import React from 'react'
import { GROUP_SORT_DATA, GROUP_UPDATE_HANDLERES } from '../constants/CNFGroupByConstants'
import { CheckMarkIcon, CloseSmallIcon } from '@core'
import { MoveIcon } from '@resources/images'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import Icon from '@components/std-components/Icons'
import { NewSortIcon } from '@components/UI-Components/svg'
import { useTranslation } from 'react-i18next'
import { useObserver } from 'mobx-react-lite'

const useStyles = makeStyles(theme => ({
  attrSelectBox: {
    backgroundColor: '#fafafa !important',
    border: '0 !important',
    '&> div': {
      display: 'flex'
    },
    '&> div > svg': {
      display: 'none'
    },
    '&> div:has(h5)': {
      display: 'flex',
      marginLeft: '10px'
    },
    '&> svg': {
      marginRight: 10
    }
  },
  sortTagDiv: {
    justifyContent: 'space-between',
    marginTop: '10px'
  },
  menuList: {
    '&> h5': {
      display: 'none'
    },
    '&> div:has(img)': {
      display: 'none'
    }
  },
  menuListDisabled: {
    opacity: 0.5
  },
  iconDiv: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
    paddingRight: 10
  },
  dragIcon: {
    padding: '0px 10px'
  },
  selectedItem: {
    display: 'flex',
    marginLeft: '10px',
    alignItems: 'center'
  },
  sortIcon: {
    display: 'flex',
    height: '24px',
    width: '24px',
    padding: '4.3px 2.96px 4.3px 2.961px',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box'
  }
}))
export const CNFGroupByRow = ({
  rowData,
  groupByAttributes,
  index,
  addedGroupByAttributes,
  applyGroupByOptions
}) => {
  return useObserver(function useHook() {
    const classes = useStyles()
    const { t } = useTranslation()

    const selectableOptions = groupByAttributes.filter(el => {
      if (el.id === rowData?.id) {
        return true
      }
      return !addedGroupByAttributes.some(i => i.id === el.id)
    })

    return (
      <>
        <Grid container>
          <Grid container>
            <Select
              className={classes.attrSelectBox}
              value={rowData.id ?? ''}
              displayEmpty
              input={<StyledBootStrapInput width={'100%'} height={'44px'} />}
              onChange={event => {
                applyGroupByOptions(GROUP_UPDATE_HANDLERES.ATTRIBUTE, {
                  id: event.target.value,
                  index
                })
              }}
            >
              <MenuItem
                key=''
                value=''
                disabled={true}
                className={classes.menuListDisabled}
              >
                <div className={classes.selectedItem}>
                  <Typography variant='caption'>
                    {t(
                      'bb.settings.productCardConfigSettings.selectAttribute',
                      'Select Attribute'
                    )}
                  </Typography>
                </div>
              </MenuItem>
              {selectableOptions.map(ele => {
                return (
                  <MenuItem key={ele.id} value={ele.id} className={classes.menuList}>
                    {ele.id === rowData.id ? (
                      <>
                        <CheckMarkIcon />
                        <Typography variant='h5'>{`H${index + 1}`}</Typography>
                      </>
                    ) : (
                      <Icon />
                    )}
                    <div className={classes.selectedItem}>
                      <Typography variant='h5DarkGrey'>
                        {t(ele.labelKey, ele.displayName)}
                      </Typography>
                    </div>
                  </MenuItem>
                )
              })}
            </Select>
          </Grid>
          <Grid container className={classes.sortTagDiv}>
            <Grid item xs={7}>
              <Select
                className={classes.attrSelectBox}
                value={rowData.sortId}
                MenuProps={{ getContentAnchorEl: null }}
                input={
                  <StyledBootStrapInput width={'100%'} height={'44px'} label={'A -> z'} />
                }
                onChange={event => {
                  applyGroupByOptions(GROUP_UPDATE_HANDLERES.SORT, {
                    sortId: event.target.value,
                    index
                  })
                }}
              >
                {GROUP_SORT_DATA.map(sortRow => {
                  return (
                    <MenuItem
                      key={sortRow.sortId}
                      value={sortRow.sortId}
                      className={classes.menuList}
                    >
                      {sortRow.sortId === rowData.sortId ? (
                        <>
                          <CheckMarkIcon />
                          <Icon
                            imageSrc={NewSortIcon}
                            alt={'sortBy'}
                            className={classes.sortIcon}
                          />
                        </>
                      ) : (
                        <Icon />
                      )}
                      <div className={classes.selectedItem}>
                        <Typography variant='caption'>{sortRow.name}</Typography>
                      </div>
                    </MenuItem>
                  )
                })}
              </Select>
            </Grid>
            <Grid container item xs={5} className={classes.iconDiv}>
              <CloseSmallIcon
                onClick={() => {
                  applyGroupByOptions(GROUP_UPDATE_HANDLERES.REMOVE_GROUP, { index })
                }}
              />
              {addedGroupByAttributes.length > 1 ? (
                <img src={MoveIcon} alt='Move' className={classes.dragIcon} />
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </>
    )
  })
}
